import { defaultLocale } from '~/constants';
import { getCurrentLanguage } from './common';

export const getSessionOfDay = () => {
  const date = new Date();
  const hh = date.getHours();

  let session = '';

  if (hh >= 5 && hh <= 11) {
    session = getCurrentLanguage() === defaultLocale ? 'sáng' : 'morning';
  } else if (hh >= 12 && hh <= 17) {
    session = getCurrentLanguage() === defaultLocale ? 'chiều' : 'afternoon';
  } else {
    session = getCurrentLanguage() === defaultLocale ? 'tối' : 'evening';
  }

  return session;
};
